<template>
  <v-container>
    <Spinner v-if="!isInitialized" />
    <router-view
      v-if="isInitialized"
      :pages="pages"
      :section="section"
      :loading="loading"
      @page:search="onSearch"
      @page:addFilter="onAddFilter"
    ></router-view>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Spinner from '../../components/shared/Spinner'

export default {
  name: 'PagesHome',
  components: {
    Spinner,
  },
  data() {
    return {
      loading: true,
      isInitialized: false,
    }
  },
  watch: {
    $route() {
      this.fetch()
    },
  },
  computed: {
    ...mapGetters('pages', { allPages: 'getArray' }),
    ...mapGetters('user', { getUserNameById: 'getUserNameById' }),
    pages() {
      return this.allPages.map((page) =>
        page.updated_by
          ? { ...page, updated_by: this.getUserNameById(page.updated_by) }
          : { ...page, updated_by: '' }
      )
    },
    section() {
      return this.$route.params.section
    },
    sortOrder() {
      switch (this.section) {
        case 'havsutsikt':
          return { key: 'page_keywords', value: 'DESC' }
        default:
          return { key: 'updated_at', value: 'DESC' }
      }
    },
  },
  methods: {
    ...mapMutations('pages', { addPagesFilter: 'ADD_FILTER', setPageOrder: 'SET_SORT' }),
    ...mapActions('pages', { getPages: 'readCollection' }),
    async fetch() {
      this.loading = true
      this.addPagesFilter({ key: 'section', value: this.section })
      await this.getPages()
      this.loading = false
    },
    onSearch(value) {
      this.addPagesFilter({ key: 'page_menu_title', value })
      this.fetch()
    },
    onAddFilter(filter) {
      this.addPagesFilter(filter)
      this.fetch()
    },
  },
  async created() {
    this.addPagesFilter({ key: 'page_publish', value: ['online'] })
    this.addPagesFilter({ key: 'pageSize', value: 9999 })
    this.setPageOrder(this.sortOrder)
    await this.fetch()
    this.isInitialized = true
  },
}
</script>

<style lang="scss" scoped></style>
